// extracted by mini-css-extract-plugin
export default {"modal_wrapper":"MyRequirementsPage_modal_wrapper__kOwWV","model_content":"MyRequirementsPage_model_content__ptwoF","close_modal_btn":"MyRequirementsPage_close_modal_btn__rWd5+"};